// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__2K4tQ"};